<template>
  <div v-if="showNav">
    <div
      id="nav"
      class="tw-bg-white tw-z-10 tw-fixed tw-w-full"
    >
      <div class="ns-container">
        <nav class="tw-relative tw-flex tw-items-center tw-justify-between md:tw-py-4">
          <div class="tw-relative tw-z-10 tw-flex-shrink-0 tw-py-4 md:tw-p-0">
            <Logo size="md" />
          </div>
          <div class="tw-flex-shrink-0 md:tw-hidden">
            <button
              ref="openButton"
              type="button"
              class="tw-block tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-900"
              aria-label="Menu"
              @click="openSidenav"
            >
              <svg
                class="tw-h-6 tw-w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6Z" />
                <path d="M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z" />
                <path d="M4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H4Z" />
              </svg>
            </button>
          </div>
          <div class="tw-hidden md:tw-block md:tw-flex md:tw-items-baseline md:tw-justify-between md:tw-bg-transparent">
            <div class=" tw-flex tw-items-center tw-justify-end tw-list-none">
              <li
                v-for="navItem in navItems"
                :key="navItem.name"
                class="nav-item"
              >
                <i-link
                  v-if="navItem.type === 'internal-link'"
                  class="nav-link"
                  :path="navItem.path"
                >
                  {{ navItem.label }}
                </i-link>

                <e-link
                  v-else-if="navItem.type === 'external-link'"
                  class="nav-link"
                  :link="navItem.link"
                >
                  {{ navItem.label }}
                </e-link>
              </li>
            </div>
            <div class="tw-ml-10 tw-relative tw-flex tw-items-baseline">
              <div
                class="tw-cursor-pointer"
                @click="openInNewWindow(links.facebookGroup)"
              >
                <rounded-icon
                  icon-style="background: #3b5998"
                  size="sm"
                  icon-class="fab fa-facebook-f"
                />
              </div>
              <router-link
                class="btn btn-icon btn-red tw-inline-flex tw-items-center"
                to="/login"
              >
                <rounded-icon
                  icon-style="background: #f01735"
                  size="sm"
                  icon-class="fas fa-user"
                />
                <span class="tw-ml-2 tw-mr-4">Login</span>
              </router-link>
            </div>
          </div>
        </nav>
      </div>

      <LandingSideNav
        :is-open="sidenavOpen"
        :nav-items="navItems"
        @close-sidenav="closeSidenav"
      />
    </div>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  components: {
    Logo: () => import(/* webpackChunkName: "page--common" */ '@/components/layout/nav/Logo'),
    LandingSideNav: () => import(/* webpackChunkName: "page--common" */ '@/components/layout/nav/LandingSideNav'),
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showNav: false,
      sidenavOpen: false,
    };
  },

  computed: {
    ...sync([
      'navigation/links', //
    ]),

    navItems() {
      return [
        {
          type: 'internal-link',
          label: 'Home',
          path: '',
        },
        {
          type: 'internal-link',
          label: 'Retreats',
          path: 'events/retreats',
        },
        {
          type: 'external-link',
          label: 'Stories',
          link: this.links.stories,
        },
        // {
        //   type: 'internal-link',
        //   label: 'FCM Push Notifications',
        //   path: 'test/fcm-push-notifications',
        // },
      ];
    },
  },

  watch: {
    sidenavOpen: {
      immediate: true,
      handler(sidenavOpen) {
        if (sidenavOpen) {
          // console.log('hiding overflow');
          document.body.style.setProperty('overflow', 'hidden');
        } else {
          // console.log('restoring overflow');
          document.body.style.removeProperty('overflow');
        }
      },
    },

    $route: {
      immediate: true,
      handler() {
        this.setNavVisibility();
        if (this.showNav) {
          this.closeSidenav();
        }
      },
    },
  },

  methods: {
    setNavVisibility() {
      this.showNav = false;

      console.log('setNavVisibility.route.name', this.$route.name);

      const routesWithNoNav = [
        'login', //
        'register',
        'forgotten-password',
      ];

      if (!routesWithNoNav.includes(this.$route.name)) {
        this.showNav = true;
      }
    },

    openSidenav() {
      this.sidenavOpen = true;
    },

    closeSidenav() {
      this.sidenavOpen = false;
      this.$nextTick(() => {
        this.$refs.openButton.focus();
      });
    },
  },
};
</script>

<style>
.nav-link {
  @apply tw-text-sm tw-font-normal tw-text-gray-900 tw-leading-normal tw-px-3 !important;
}
.nav-link:hover {
  @apply tw-text-gray-700;
}
</style>
